<template>
  <v-container fluid ma-0 pa-0>
    <v-layout row>
      <v-flex class="xs12">
        <v-layout row class="mediumMargin layouttitletop myrow">
          <v-flex xs12 class="pagecontainer">
            <v-layout align-center justify-space-between>
              <div class="header-title">{{ labels.header }}</div>
              <v-btn color="primary" @click="onNewResourceClick">{{ labels.newResourceButtonLabel }} <span
                class="icon-plus"></span></v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-flex class="searchbox">
          <div class="inlinebox">
            <v-text-field v-model="buyerName" :placeholder="labels.searchLabel" class="searchbuyerinput"
              @keydown.enter="onSearchByBuyerName">
            </v-text-field>
            <span v-if="buyerName.length > 0" v-on:click="clearSearchBox()" class="glyphicon glyphicon-remove-circle searchclear"></span>
          </div>
        </v-flex>
        <v-layout row>
          <v-flex xs12>
            <v-data-table
              :headers="buyerClaimsHeaders"
              :loading="isLoading"
              :items="filteredBuyerClaims"
              item-key="id"
              :pagination.sync="pagination"
              :rows-per-page-items="[5, 10, 50, 100]"
              :total-items="totalItems"
              class="elevation-1">
              <template v-slot:headers="props">
                <tr>
                  <template v-for="header in props.headers">
                    <th :key="header.text" class="text-xs-left">
                      {{ header.text }}
                    </th>
                  </template>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr @click="showDetails(props.item.id)"
                    :class="selectedBuyerClaimId === props.item.id ? 'selectedrow' : ''">
                  <td class="text-xs-left">
                    {{ props.item.buyerCompanyName }}<br/>
                    <span class="smalltext greytext">AZ Id: {{ props.item.buyerCompanyId }}</span>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.policy.businessUnitCode }} {{ props.item.policy.policyId }}
                    {{ !!props.item.policy.extensionId ? ' - ' + props.item.policy.extensionId : '' }}
                  </td>
                  <td class="text-xs-left">
                    {{ $toTitleCase(props.item.claimStatusDescriptionCode.replaceAll("_", " ")) }}<br/>
                    <span v-if="props.item.claimStatusCode === 'DR' && !!props.item.submissionTimestamp" class="claim-processing"><p class="centerText"> Processing</p></span>
                  </td>
                  <td class="text-xs-left">
                    {{ $formatDate(props.item.creationDate) }}
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                <div v-if="isLoading" class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div v-else>
                  <p class="centerText">{{ labels.emptyDataLabel }}</p>
                </div>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <BuyerClaimDetails v-model="showBuyerClaimDetails" @buyerClaimUpdated="onBuyerClaimUpdated" :buyer-claim-id="selectedBuyerClaimId"/>
  </v-container>
</template>

<script>
import BuyerClaimDetails from '@/components/cover/buyerclaims/BuyerClaimDetails.vue'
import coverApi from '@/services/CoverApi'

export default {
  name: 'ListBuyerClaim',
  components: {
    BuyerClaimDetails
  },
  data () {
    return {
      labels: {
        header: this.$t('BuyerClaims.BuyerClaimsList.TITLE'),
        newResourceButtonLabel: this.$t('BuyerClaims.BuyerClaimsList.DECLARE_CLAIM_BTN'),
        emptyDataLabel: this.$t('BuyerClaims.BuyerClaimsList.NO_DATA_LABEL'),
        searchLabel: this.$t('BuyerClaims.BuyerClaimsList.SEARCH_LABEL')
      },
      isLoading: false,
      showBuyerClaimDetails: false,
      buyerClaims: [],
      buyerClaimsHeaders: [
        {
          text: this.$t('BuyerClaims.BuyerClaimsList.BUYER_COLUMN_HEADER'),
          align: 'left',
          sortable: false,
          value: 'buyerCompanyName'
        },
        {
          text: this.$t('BuyerClaims.BuyerClaimsList.POLICY_COLUMN_HEADER'),
          align: 'left',
          sortable: false,
          value: 'policy'
        },
        {
          text: this.$t('BuyerClaims.BuyerClaimsList.CLAIM_STATUS_COLUMN_HEADER'),
          align: 'left',
          sortable: false,
          value: 'claimStatusDescriptionCode'
        },
        {
          text: this.$t('BuyerClaims.BuyerClaimsList.CLAIM_CREATION_DATE_COLUMN_HEADER'),
          align: 'left',
          sortable: false,
          value: 'creationDate'
        }
      ],
      selectedBuyerClaimId: undefined,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      },
      totalItems: 0,
      buyerName: ''
    }
  },
  methods: {
    onNewResourceClick () {
      this.selectedBuyerClaimId = undefined
      this.showBuyerClaimDetails = true
    },
    async loadBuyerClaims (page, pageSize) {
      this.isLoading = true
      try {
        const buyerClaimsData = await coverApi.getBuyerClaims(page - 1, pageSize, this.buyerName)

        const buyerClaimIds = buyerClaimsData.items.map(item => item.id)
        const buyerClaimsExtendedInfoData = await coverApi.getBuyerClaimsExtendedInfo(buyerClaimIds)

        this.buyerClaims = this.mergeBuyerClaimsArrays(buyerClaimsData.items, buyerClaimsExtendedInfoData)
        this.totalItems = buyerClaimsData.totalCount
      } catch (e) {
        this.buyerClaims = []
      } finally {
        this.isLoading = false
      }
    },
    showDetails: function (value) {
      this.selectedBuyerClaimId = value
      this.showBuyerClaimDetails = !!value
    },
    async onBuyerClaimUpdated () {
      await this.loadBuyerClaims(this.pagination.page, this.pagination.rowsPerPage)
    },
    async onSearchByBuyerName () {
      if (this.pagination.page === 1) { await this.loadBuyerClaims(this.pagination.page, this.pagination.rowsPerPage) } else { this.pagination.page = 1 }
    },
    async clearSearchBox () {
      this.buyerName = ''
      await this.onSearchByBuyerName()
    },
    mergeBuyerClaimsArrays: function (firstArray, secondArray) {
      return firstArray.map(item => {
        const match = secondArray.find(x => x.claimId === item.id)
        delete match.claimId
        return match ? Object.assign({}, item, match) : item
      })
    }
  },
  computed: {
    filteredBuyerClaims: function () {
      return [...this.buyerClaims]
    }
  },
  watch: {
    pagination: {
      async handler () {
        await this.loadBuyerClaims(this.pagination.page, this.pagination.rowsPerPage)
      },
      deep: true
    }
  }
}
</script>

<style scoped>

>>> .theme--light.v-table tbody tr, td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.claim-processing {
  border-radius: 12.5px;
  background-color: #dbecff;
  color: #090cec;
  width: 70px;
  height: 24px;
  display: inline-block;
  font-size: 12px;
  padding: 2px;
}

</style>
